import { render, staticRenderFns } from "./ServicoListFiltroModalItemInputStatus.vue?vue&type=template&id=10154ed2"
import script from "./ServicoListFiltroModalItemInputStatus.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItemInputStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports